import { useState } from 'react'
import {
    Modal
} from "reactstrap"

import { DeleteHelper } from '../modules/Masters/CallHelper'
import { get } from 'helpers/api_helper'
import Notifications from "components/Notifications";

const DeleteConfirmationModel = ({isOpen, changeState, code, other = false}) => {
    const [checked, setChecked] = useState(false);
    const [inputCode, setInputCode] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text);
        Notifications('Code copied to clipboard!', 'success');
    };

    console.log(code)

    const deleteRow = async() => {
        if(code.code == inputCode){
            const res = await !code?.other ? DeleteHelper(code.url, code.q, code.status, checked, code?.isMaster) : get(`${code.url}&visable=${Number(checked)}`)
            if(res){
                code.status == 1 ? Notifications(`record ${checked ? 'prominently deleted' : 'deleted'} successfully.!`, 'error') : Notifications('record restored successfully.!')
                changeState(false)
            }
        }else{
            alert('please enter code');
        }
    }

    return (
        <Modal
            size="md"
            isOpen={isOpen}
            toggle={() => changeState(false)}
            centered={true}
        >
            <div className="modal-body">
                <div className="d-flex align-items-center mb-3">
                    <p className="mb-0">Please enter the following code to {code.status == 0 ? 'delete' : 'activate'}:</p>
                </div>
                <div className="code-container d-flex align-items-center bg-light p-2 rounded mb-3">
                    <code className="me-2"><b>{code.code}</b></code>
                    <button 
                        className="btn btn-sm btn-outline-secondary"
                        onClick={() => copyToClipboard(code.code)}
                    >
                        <i className="fas fa-copy"></i>
                    </button>
                </div>
                <input 
                    name="code" 
                    placeholder="Enter the code here"
                    onChange={(e) => setInputCode(e.target.value)} 
                    className="form-control" 
                /> 
                {
                    code.status == 1 &&
                    <div className="mt-3">
                        <input
                            type="checkbox"
                            checked={checked}
                            onChange={() => setChecked(!checked)}
                        /> 
                        <span className="ms-2">Delete permanently</span>
                    </div>
                }
            </div>
            <div className="modal-footer">
                <button 
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => changeState(false)} >Close</button>
                <button 
                    type="button"
                    disabled={ (!isLoading && code.code == inputCode) ? false : true }
                    className={`btn btn-${code.status == 0 ? 'danger' : 'success' } `}
                    onClick={() => {
                        setIsLoading(true);
                        deleteRow()
                    }} >{code.status == 0 ? 'Delete' : 'Activate' } {isLoading && <i className='fas fa-spinner fa-spin'/>}</button>
            </div>
        </Modal>
    )
}

export default DeleteConfirmationModel